const keyType = {
    "Telefone": {
        "placeholder": "+55 11 99999-9999",
        "type": "tel",
        "aria-label": "Telefone Cadastrado no PIX, Digite Somente números, máscara será aplicada",
        "inputmode": "tel",
        "maskOption": {
            mask: '+55 00 00000-0000',
            dispatch: null
        }
    },
    "CPF": {
        "placeholder": "222.222.222-22",
        "type": "text",
        "aria-label": "CPF Cadastrado no PIX, Digite Somente números, máscara será aplicada",
        "inputmode": "numeric",
        "maskOption": {
            "mask": "000.000.000-00",
            dispatch: null
        }
    },
    "CNPJ": {
        "placeholder": "99.999.999/9999-99",
        "type": "text",
        "aria-label": "CNPJ Cadastrado no PIX, Digite Somente números, máscara será aplicada",
        "inputmode": "numeric",
        "maskOption": {
            "mask": "00.000.000/0000-00",
            dispatch: null
        }
    },
    "Email": {
        "placeholder": "exemplo@exemplo.com.br",
        "type": "email",
        "aria-label": "EMAIL Cadastrado no PIX",
        "inputmode": "email"
    },
    "Outro": {
        "placeholder": "CHAVE-PIX-ALPHANUMERICA",
        "type": "text",
        "aria-label": "Chave Alphanúmerica Cadastrado no PIX",
        "inputmode": "text"
    }
};

export default keyType;